export default __webpack_public_path__ + "img/83dce9e859090f18b6d72c3263250367.svg";